import {useState} from 'react'
import EditIcon from '../../media/felsv/down-arrow-svgrepo-com.svg'
import {
  DescuentoGlobalForm,
  PORCENTAJE_MAXIMO,
  TipoDescuentoGlobal,
  esEntradaDescuentoValida,
} from '../../utils/descuentoGlobal'

interface DescuentoGlobalProps {
  form: DescuentoGlobalForm
  onChange: (cambios: Partial<DescuentoGlobalForm>) => void
  /** Descuento global ya calculado (suma de los tres tipos de venta) */
  descuentoAplicado?: number | string
  /** Mensaje de validacion del calculo; vacio si el descuento es valido */
  error?: string
  /** Sin productos no hay base sobre la cual aplicar el descuento */
  deshabilitado?: boolean
}

const colorError = 'rgba(247, 29, 29, 0.978)'

export default function DescuentoGlobal({form, onChange, descuentoAplicado, error, deshabilitado}: DescuentoGlobalProps) {
  const [showContent, setShowContent] = useState(false)
  const esPorcentaje = form.tipo === 'porcentaje'
  const aplicado = parseFloat(`${descuentoAplicado ?? 0}`) || 0

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div style={{width: '100%', boxShadow: 'none'}} className='card'>
        <h3
          className='card-title l'
          onClick={() => setShowContent(!showContent)}
          style={{cursor: 'pointer', display: 'flex', alignItems: 'center'}}
        >
          Descuento global
          {aplicado > 0 && (
            <span style={{marginLeft: '12px', fontSize: '12px', color: colorError}}>-${aplicado.toFixed(2)}</span>
          )}
          <img src={EditIcon} style={{marginLeft: '16px', width: '15px'}} alt='' />
        </h3>

        {showContent && (
          <>
            <div className='form-separator' />

            <div className='form-content'>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label className='field-label m'>Tipo de descuento</label>
                  <select
                    className='m text-field w-input'
                    value={form.tipo}
                    disabled={deshabilitado}
                    onChange={(e) => onChange({tipo: e.target.value as TipoDescuentoGlobal, valor: ''})}
                  >
                    <option value='monto'>Monto fijo ($)</option>
                    <option value='porcentaje'>Porcentaje (%)</option>
                  </select>
                </div>

                <div className='label-input'>
                  <label className='field-label m'>{esPorcentaje ? 'Porcentaje' : 'Monto'}</label>
                  <input
                    type='text'
                    inputMode='decimal'
                    className='m text-field w-input'
                    value={form.valor}
                    disabled={deshabilitado}
                    placeholder={esPorcentaje ? 'Ej: 14.05' : 'Ej: 25.00'}
                    maxLength={12}
                    onChange={(e) => {
                      if (esEntradaDescuentoValida(e.target.value)) onChange({valor: e.target.value})
                    }}
                  />
                </div>
              </div>

              <p style={{fontSize: '11px', color: 'rgba(27, 27, 27, 0.4)', marginTop: '4px'}}>
                Se resta una sola vez del total de la venta; los productos conservan su precio.
                {esPorcentaje
                  ? ` Admite hasta 2 decimales (ej. 14.05). Máximo ${PORCENTAJE_MAXIMO}%.`
                  : ' Admite hasta 2 decimales.'}
              </p>

              {error ? (
                <p style={{fontSize: '12px', color: colorError, marginTop: '8px'}}>{error}</p>
              ) : (
                aplicado > 0 && (
                  <p style={{fontSize: '12px', marginTop: '8px'}}>
                    Descuento aplicado: <strong style={{color: colorError}}>-${aplicado.toFixed(2)}</strong>
                  </p>
                )
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
